import { useContext } from "react";
import type { AuthContextType } from "./auth/types";
import { AuthContext } from "@/hooks/auth/AuthContext";

// Custom hook for accessing auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
